export const SEQUENCER_FEE_ADDR = '0x4200000000000000000000000000000000000011';
export const L1_FEE_ADDR = '0x420000000000000000000000000000000000001A';
export const BASE_FEE_ADDR = '0x4200000000000000000000000000000000000019';
